export default __webpack_public_path__ + "static/media/info-icon-blue.5a7be841.svg";